import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { setDialog } from "../../../../../app/slices/capitalAmountSlice";
import CapitalAmountForm from "../../form";
import { GiMoneyStack } from "react-icons/gi";
import Permission from "../../../../../components/userPermission/userPermission";

const CapitalAmountHeader = () => {
  const _CapitalAmount = useSelector((state) => state.capitalAmount);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            رأس المال
          </Typography>
        }
        avatar={<GiMoneyStack size={20} />}
        action={
          <Permission permission="capital_amount_edit">
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              إضافة رأس مال جديد
            </Button>
          </Permission>
        }
      />
      {_CapitalAmount.capitalAmount.dialog ? <CapitalAmountForm /> : null}
    </Card>
  );
};

export default CapitalAmountHeader;
